export default __webpack_public_path__ + "static/media/ZK810.66bdb253.pdf";